<template>
  <div>
    <template>
      <h3 class="headline mb-3" :style="{ color: theme.color }">
        เพิ่มที่อยู่จัดส่ง
      </h3>
      <div :class="{ 'has-error': errors.has('customerName') }" class="mb-1">
        <v-text-field
          :label="$t('Name')"
          :data-vv-as="$t('Name')"
          outline
          name="customerName"
          v-validate="$route.query.shoptoken ? '' : 'required'"
          v-model="customerName"
          light
          :color="theme.color"
          :error="errors.has('customerName') ? true : false"
          :error-messages="
            errors.has('customerName') ? errors.first('customerName') : ''
          "
          @blur="onBlurAddress"
        ></v-text-field>
      </div>
      <div :class="{ 'has-error': errors.has('zipcode') }" class="mb-1">
        <thai-address-input
          v-model="input.zipcode"
          type="zipcode"
          @select="onSelectAddress"
          :label="$t('zipcode')"
          :data-vv-as="$t('zipcode')"
          outline
          name="zipcode"
          v-validate="{
            required: true
          }"
          light
          :color="theme.color"
          :error="errors.has('zipcode') ? true : false"
          :error-messages="errors.has('zipcode') ? errors.first('zipcode') : ''"
        ></thai-address-input>
      </div>
      <div :class="{ 'has-error': errors.has('province') }" class="mb-1">
        <thai-address-input
          v-model="input.province"
          type="province"
          @select="onSelectAddress"
          :label="$t('province')"
          :data-vv-as="$t('province')"
          outline
          name="province"
          v-validate="{
            required: true
          }"
          light
          :color="theme.color"
          :error="errors.has('province') ? true : false"
          :error-messages="
            errors.has('province') ? errors.first('province') : ''
          "
        ></thai-address-input>
      </div>
      <div :class="{ 'has-error': errors.has('amphoe') }" class="mb-1">
        <thai-address-input
          v-model="input.district"
          type="amphoe"
          @select="onSelectAddress"
          :label="$t('amphoe')"
          :data-vv-as="$t('amphoe')"
          outline
          name="amphoe"
          v-validate="{
            required: true
          }"
          light
          :color="theme.color"
          :error="errors.has('amphoe') ? true : false"
          :error-messages="errors.has('amphoe') ? errors.first('amphoe') : ''"
        ></thai-address-input>
      </div>
      <div :class="{ 'has-error': errors.has('district') }" class="mb-1">
        <thai-address-input
          v-model="input.sub_district"
          type="district"
          @select="onSelectAddress"
          :label="$t('district')"
          :data-vv-as="$t('district')"
          outline
          name="district"
          v-validate="{
            required: true
          }"
          light
          :color="theme.color"
          :error="errors.has('district') ? true : false"
          :error-messages="
            errors.has('district') ? errors.first('district') : ''
          "
        ></thai-address-input>
      </div>
    </template>
    <div :class="{ 'has-error': errors.has('shippingAddress') }" class="mb-1">
      <v-textarea
        outline
        :label="$t('Address No.')"
        name="shippingAddress"
        rows="5"
        :data-vv-as="$t('Address No.')"
        style="resize: none; width: 100%"
        v-model="shippingAddress"
        :placeholder="$t('Ex. Address No., Village, Alley, and Road')"
        v-validate="{
          required: true
        }"
        light
        :color="theme.color"
        :error="errors.has('shippingAddress') ? true : false"
        :error-messages="
          errors.has('shippingAddress')
            ? `${errors.first('shippingAddress')}`
            : ''
        "
      ></v-textarea>
    </div>

    <div style="clear: both"></div>

    <div :class="{ 'has-error': errors.has('customerPhone') }" class="mb-1">
      <v-text-field
        :label="$t('Tel.') + ' ( Ex. 0999999999 ) '"
        :data-vv-as="$t('Tel.')"
        outline
        tyle="tel"
        :mask="'##########'"
        name="customerPhone"
        light
        :color="theme.color"
        v-validate="{
          required: true,
          regex: /(\d{10})/
        }"
        v-model="customerPhone"
        :error="errors.has('customerPhone') ? true : false"
        :error-messages="
          errors.has('customerPhone') ? errors.first('customerPhone') : ''
        "
      ></v-text-field>
    </div>
    <v-layout
      row
      nowrap
      justify-space-between
      v-if="['tremendous'].includes(pageProfile.type)"
    >
      <v-flex xs class="mr-2">
        <v-text-field
          label="Latitude"
          outline
          tyle="text"
          name="latitude"
          light
          :color="theme.color"
          v-validate="{
            required: true
          }"
          disabled
          v-model="address_lat"
        ></v-text-field>
      </v-flex>
      <v-flex xs>
        <v-text-field
          label="Longitude"
          outline
          tyle="text"
          name="longitude"
          light
          :color="theme.color"
          v-validate="{
            required: true
          }"
          disabled
          v-model="address_long"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <div class="mb-3" v-if="['tremendous'].includes(pageProfile.type)">
      <template>
        <gmap-address
          v-if="showmap && showmapLocal"
          :placesinfo="placesinfolabel"
          v-validate="{
            required: $route.query.shoptoken ? false : true
          }"
          name="ปักหมุดที่อยู่"
          v-model="gmapvalue"
          v-on:input="gmapLocation"
          :lastordercoords="gmapvalue"
          :error="errors.has('ปักหมุดที่อยู่')"
          :radius="0"
          :scrollable="true"
          :infoloading="loadingMapInfo"
          @onMapLoading="onMapLoading"
          @onMapReady="onMapReady"
          @select="handleGmapAddressSelect"
        ></gmap-address>
        <input
          v-validate="'is:true'"
          type="hidden"
          name="isLocationSelected"
          :value="String(isLocationSelected)"
        />
        <v-messages
          v-if="errors.has('isLocationSelected')"
          color="error"
          :value="[$t('require_shipping_location')]"
          class="mt-2"
        />
      </template>
    </div>
    <div>
      <v-checkbox
        style="font-weight: 400"
        label="ตั้งเป็นที่อยู่เริ่มต้น"
        v-model="input.main_address"
        color="primary"
      ></v-checkbox>
    </div>
    <div class="text-xs-center">
      <v-btn outline color="grey" @click="handleCancel">{{
        $t('cancel')
      }}</v-btn>
      <v-btn
        depressed
        color="primary"
        :loading="saveLoading"
        @click="handleSave"
        >{{ $t('Save') }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import config from '@/config'
import axios from 'axios'
import nl2br from 'vue-nl2br'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'

import BankNumber from '@/components/BankNumber.vue'
import Cover from '@/components/Cover.vue'
import DatePicker from '@/components/DatePicker.vue'
import DatepickerCustomDialog from '@/components/DatepickerCustomDialog.vue'
import CartSummary from '@/components/ecommerce/CartSummary.vue'
import EditCartSummary from '@/components/ecommerce/EditCartSummary.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import ShippingType from '@/components/ecommerce/ShippingType.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'
import CartItem from '@/components/payment/CartItem.vue'
import UploadFile from '@/components/UploadFile.vue'

import NativeSelect from '@/components/NativeSelect.vue'
import ThaiAddressInput from '@/components/ThaiAddressInput'

import GmapAddress from '@/components/ecommerce/GmapAddress2.vue'
import VoucherCodeInput from '@/components/ecommerce/VoucherCodeInput'
import VueOtpBox from 'vue-otp-box'
import 'vue-otp-box/dist/VueOtpBox.css'

import DefaultPaymentButton from '@/components/ecommerce/Payment/DefaultPaymentButton.vue'

import * as Sentry from '@sentry/vue'

export default {
  props: ['formType', 'value', 'showmap'],
  components: {
    VueOtpBox,
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    nl2br,
    UploadFile,
    TermAndCondition,
    CartItem,
    BankNumber,
    ShippingType,
    CartSummary,
    EditCartSummary,
    NativeSelect,
    ThaiAddressInput,
    VoucherCodeInput,
    GmapAddress,
    DatePicker,
    DatepickerCustomDialog,
    DefaultPaymentButton
  },
  data() {
    return {
      input: {
        address: '',
        zipcode: '',
        province: '',
        district: '',
        sub_district: '',
        main_address: false
      },
      customerName: null,
      customerPhone: null,
      shippingAddress: null,
      placesinfolabel: null,
      loadingMapInfo: true,
      gmapvalue: null,
      saveLoading: false,
      address_lat: '',
      address_long: '',
      showmapLocal: false,
      isLocationSelected: false
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme',
      getSalePage: 'getSalePage',
      totalBeforeVat: 'totalBeforeVat'
    })
  },
  mounted() {
    try {
      if (this.value) {
        this.onMapLoading(true)
        const address = this.value.address

        if (address) {
          this.customerName = address.name
          this.shippingAddress = address.address
          this.input.zipcode = address.zipcode
          this.input.province = address.province
          this.input.district = address.district
          this.input.sub_district = address.sub_district
          this.input.main_address = this.value.main_address
          this.address_lat = this.value.address_lat
          this.address_long = this.value.address_long
          this.customerPhone = address.tel
          if (this.value.address_lat && this.value.address_long) {
            this.gmapvalue = {
              lat: parseFloat(this.value.address_lat),
              lng: parseFloat(this.value.address_long)
            }
            this.isLocationSelected = true
          }
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.onMapLoading(false)
      this.showmapLocal = true
    }
  },
  methods: {
    onMapLoading(val) {
      this.loadingMapInfo = val
    },
    onMapReady() {
      // Ready
      this.loadingMap = false
    },
    gmapLocation() {
      if (!this.loadingMapInfo) {
        this.address_lat = this.gmapvalue.lat
        this.address_long = this.gmapvalue.lng
      }
    },
    onBlurAddress() {
      let json = {
        userid: this.userid,
        name: this.customerName,
        phone: this.customerPhone,
        addresno: this.shippingAddress,
        address: this.input,
        email:
          this.shopOption &&
          this.shopOption.length > 0 &&
          this.shopOption[2].message
            ? this.shopOption[2].message
            : ''
      }
      let tmpaddress = []
      try {
        if (localStorage.getItem('tmpaddress')) {
          tmpaddress = JSON.parse(localStorage.getItem('tmpaddress'))

          if (typeof tmpaddress != 'object') {
            tmpaddress = []
          }
        }
      } catch (error) {
        //
      }
      try {
        let index = tmpaddress.findIndex((el) => {
          return el.userid == this.userid
        })
        if (index == -1) tmpaddress.push(json)
        else tmpaddress[index] = json
        localStorage.setItem('tmpaddress', JSON.stringify(tmpaddress))
      } catch (error) {
        //
      }

      if (this.updateAddressTimeout) {
        clearTimeout(this.updateAddressTimeout)
      }
      // this.fetchLoading = true
      this.updateAddressTimeout = setTimeout(() => {
        this.setAddress(json)
      }, 3000)
    },
    onSelectAddress(address) {
      this.input.sub_district = address.district || ''
      this.input.district = address.amphoe || ''
      this.input.province = address.province || ''
      this.input.zipcode = address.zipcode || ''
    },
    requiredCharacterLength(params) {
      try {
        if (config.env !== 'shopcommu') {
          if (params.requiredNineCharacter && params.requiredTenCharacter) {
            return /^\s*-?[0-9]{9,10}\s*$/
          } else if (
            params.requiredNineCharacter &&
            !params.requiredTenCharacter
          ) {
            return /^\s*-?[0-9]{9}\s*$/
          } else if (
            !params.requiredNineCharacter &&
            params.requiredTenCharacter
          ) {
            return /^\s*-?[0-9]{10}\s*$/
          } else {
            return /^\s*-?[0-9]{1,100}\s*$/
          }
        } else {
          return /^\s*-?[0-9]{9,10}\s*$/
        }
      } catch (error) {
        return /^\s*-?[0-9]{9,10}\s*$/
      }
    },
    async handleSave() {
      const vm = this

      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          vm.goToErrorInput()
          if (!vm.isLocationSelected) {
            vm.$swal.fire({
              text: 'กรุณาเลือกสถาณที่จัดส่ง',
              type: 'error'
            })
          }
          return false
        }

        let { shippingAddress } = this.formattedCombineAddress()

        vm.saveLoading = true
        let response = null
        if (vm.formType === 'add') {
          response = await vm.createAddress(shippingAddress)
        } else {
          response = await vm.updateAddress(shippingAddress)
        }

        vm.saveLoading = false

        if (response && response.status === 200) {
          vm.$emit('saveSuccess')
        }

        // eslint-disable-next-line
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    async createAddress(address) {
      const vm = this
      try {
        const pageId = vm.pageProfile.pageid
        const userId = vm.$route.query && vm.$route.query.userid
        const url = `${config.getConfig(
          'serverUrl'
        )}api/tremendous/liff/${pageId}/shipping-address/${userId}`
        const resposne = await axios.post(
          url,
          {
            address: address,
            main_address: vm.input.main_address,
            address_lat: this.address_lat,
            address_long: this.address_long
          },
          {
            headers: { AUTHORIZATION: 'Bearer xxxx xxx' }
          }
        )

        if (resposne) {
          return resposne
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    async updateAddress(address) {
      const vm = this
      try {
        const pageId = vm.pageProfile.pageid
        const id = vm.value && vm.value.id
        const url = `${config.getConfig(
          'serverUrl'
        )}api/tremendous/liff/${pageId}/shipping-address/${id}`
        const resposne = await axios.patch(
          url,
          {
            address: address,
            main_address: vm.input.main_address,
            address_lat: this.address_lat,
            address_long: this.address_long
          },
          {
            headers: { AUTHORIZATION: 'Bearer xxxx xxx' }
          }
        )

        if (resposne) {
          return resposne
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    handleCancel() {
      this.input.sub_district = ''
      this.input.district = ''
      this.input.province = ''
      this.input.zipcode = ''
      this.$emit('close')
    },
    formattedCombineAddress() {
      const vm = this
      try {
        let combineAddress = vm.shippingAddress
          ? vm.shippingAddress.replace(/,/g, '')
          : ''
        let shippingAddress = {}

        if (
          vm.input.sub_district &&
          vm.input.district &&
          vm.input.province &&
          vm.input.zipcode
        ) {
          const inBangkok = vm.input.province == 'กรุงเทพมหานคร'
          combineAddress = combineAddress.replace(vm.input.zipcode, '')
          combineAddress =
            combineAddress +
            ' , ' +
            [
              (inBangkok ? 'แขวง' : 'ตำบล') +
                vm.input.sub_district.replace(/,/g, ''),
              (inBangkok ? 'เขต' : 'อำเภอ') +
                vm.input.district.replace(/,/g, ''),
              'จังหวัด' + vm.input.province.replace(/,/g, ''),
              vm.input.zipcode.replace(/,/g, '')
            ].join(' , ')

          shippingAddress = {
            name: vm.customerName,
            province: vm.input.province.replace(/,/g, ''),
            zipcode: vm.input.zipcode.replace(/,/g, ''),
            district: vm.input.district.replace(/,/g, ''),
            sub_district: vm.input.sub_district.replace(/,/g, ''),
            address: vm.shippingAddress
              ? vm.shippingAddress.replace(/,/g, '')
              : '',
            tel: vm.customerPhone
          }
        }

        return {
          combineAddress,
          shippingAddress
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    },
    handleGmapAddressSelect() {
      this.isLocationSelected = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
